import React, {useContext, useState} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import dayjs, {Dayjs} from "dayjs";
import UserLoginContext from "../context/userLoginContext";
import {mapPathWithCategories, MediaHubTabs} from "../page-components/media-hub/utils/utils";
import MediaHubView from "../page-components/media-hub/media-hub.view";
import '../styles/component/media-hub.scss'

const MediaHub = () => {
    const {user} = useContext(UserLoginContext);
    const isAdmin = user.isAdmin;
    const navigate = useNavigate();
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean)
    const categoryActive = mapPathWithCategories(pathSegments);

    const [date, setDate] = useState<Dayjs>(dayjs());

    const eventId = location.state?.eventId ?? null;

    const showFolder = (categoryActive === 'Events' ||
        categoryActive === 'Trainings' ||
        categoryActive === 'Birthdays') && !eventId;

    const handleTabChange = async (path: string) => {
        navigate(path, {replace: true});
    };

    const onYearChange = (year: Dayjs) => {
        setDate(year);
    }


    return (
        <MediaHubView
            showFolder={showFolder}
            tabs={MediaHubTabs}
            handleTabChange={handleTabChange}
            categorySelected={categoryActive}
            isAdmin={isAdmin}
            date={date}
            onYearChange={onYearChange}
        />
    )
}

export default MediaHub;
